











































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import ApiLegacy from '@finx/web-repository/src/apis/Legacy/Legacy'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import AssinaturaStore from '@/store/Assinaturas'

@Component

export default class ViewAceite extends Vue {
  loading: Boolean = false
  modalPolicy: Boolean = false
  modalTerms: Boolean = false

  get isAssinaturaDemonstacao() {
    return AssinaturaStore.getters.ASSINATURA_DEMONSTRACAO
  }

  async accept() {
    this.loading = true
    const accept = await ApiLegacy.Terms.acceptTermsStatus()

    if (this.isAssinaturaDemonstacao) this.$router.push('/planos')
    else this.$router.push('/')
  }

  logout(): void {
    this.$router.push('/logout')
  }
}
